// extracted by mini-css-extract-plugin
module.exports = {"main_title":"SectionTitle_main_title__niZGn"};